import { useTranslation } from "react-i18next";

interface NoSearchResultProps {
    title?: string;
    message?: string;
    showIcon?: boolean;
}

const NoSearchResult = ({ title, message, showIcon = true }: NoSearchResultProps) => {
    const { t } = useTranslation();

    const displayTitle = title || t('Common.no_result_title');
    const displayMessage = message || t('Common.no_result_message');

    return (
        <>
            <div className="noresult">
                <div className="text-center">
                    {showIcon && (
                        <i className="bi bi-exclamation-triangle text-warning display-5"></i>
                    )}
                    <h5 className={showIcon ? "mt-2" : "mt-4"}>{displayTitle}</h5>
                    <p className="text-muted mb-0">{displayMessage}</p>
                </div>
            </div>
        </>
    )
};

export default NoSearchResult;